import { type FC, useEffect, useState } from "react";
import type { DateRange, Matcher } from "react-day-picker";

import { Calendar } from "@/components/ui/calendar";

interface DateRangeSubMenuProps {
  category: string;
  initialRange?: DateRange;
  onApply: (category: string, range: DateRange) => void;
  numberOfMonth?: number;
  disabledDays?: Matcher | Matcher[];
}

const DateRangeSubMenu: FC<DateRangeSubMenuProps> = ({
  category,
  initialRange,
  onApply,
  numberOfMonth = 2,
  disabledDays,
}) => {
  const [range, setRange] = useState<DateRange | undefined>(initialRange);

  useEffect(() => {
    setRange(initialRange);
  }, [initialRange]);

  useEffect(() => {
    if (
      range?.from &&
      range?.to &&
      (range.from.getTime() !== initialRange?.from?.getTime() ||
        range.to.getTime() !== initialRange?.to?.getTime())
    ) {
      onApply(category, range);
    }
  }, [range, category, onApply, initialRange]);

  return (
    <div className="px-2 py-2 flex flex-col gap-2">
      <Calendar
        mode="range"
        selected={range}
        onSelect={setRange}
        numberOfMonths={numberOfMonth}
        data-testid="date-range-submenu-calendar"
        className="px-0"
        disabled={disabledDays}
      />
    </div>
  );
};

export default DateRangeSubMenu;
